import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { SupportInfo } from "@/models/SupportInfoModel.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { Typography, TypographyProps } from "@/uiKit/atoms/Typography.tsx";

export type ContactSupportProps = TypographyProps & {
  support: SupportInfo;
};

export const ContactSupport: React.FC<ContactSupportProps> = ({ support, ...props }) => {
  const { t } = useTranslation();
  return (
    <Typography component="span" {...props}>
      {t("support.contactUs")}
      <ContactSupportInfo support={support} />
    </Typography>
  );
};

export const ContactSupportInfo: React.FC<ContactSupportProps> = ({ className, support }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <Typography component="span" className={className}>
      {`${t("support.byEmail")} `}
      <Button
        data-action="account.support.email"
        component="a"
        variant="text"
        href={`mailto:${support.supportEmail}`}
        className={styles.link}
      >
        {support.supportEmail}
      </Button>
      {` ${t("support.or")} ${t("support.byPhone")} `}
      <Button
        data-action="account.support.call"
        component="a"
        variant="text"
        href={`tel:${support.supportPhoneNumber}`}
        className={styles.link}
      >
        {support.supportPhoneNumber}
      </Button>
    </Typography>
  );
};

const makeStyles = () => ({
  link: css({
    color: "inherit !important",
    cursor: "pointer",
  }),
});
